import React, { useEffect, useState } from "react";
import { Exercise } from "../../../models/Exercise";
import useEvents from "../hooks/useEvents";
import "./style.scss";
import "../../../../style/feature.scss";
import "../../../../style/block.scss";
import "../../../../style/buttons.scss";
import { HiOutlineTicket } from "react-icons/hi";
import TicketLineSummary from "../../Universal/TicketLineSummary";
import PreBasketSummary from "../../Universal/PreBasketSummary";
import usePreBasket from "../../Universal/hooks/usePreBasket";
import useBasketManager from "../../FinalizePage/hooks/useBasketManager";
import { useTranslation } from "react-i18next";
import useCalculatePreBasketQnt from "../../Universal/hooks/useCalculatePreBasketQnt";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import EAProductBanner from "../../shared/ProductBanner/EAProductBanner";

interface IProps {
  item: Exercise;
}

const EventSingle: React.FC<IProps> = ({ item }) => {
  const { t } = useTranslation();
  const { getTicketsForEvent, tickets } = useEvents();
  const [open, setOpen] = useState(false);
  const { formatTicketAccess, ticketAccess } = useEvents();
  const { preBasket, addItemToBasket, removeItemFromBasket, clearBasket } = usePreBasket();
  const { getBasket } = useBasketManager();
  const { qntState } = useCalculatePreBasketQnt(preBasket);
  const showTicketLimits = useSelector((state: State) => state.config.configuration.showTicketsPoolForEventsSale);
  const lowestPrice = tickets.reduce((r, b) => Math.min(r, b.price), Number.POSITIVE_INFINITY);
  const handleDeleteBasket = () => {
    clearBasket();
    setTimeout(() => {
      getBasket();
    }, 200);
  };

  useEffect(() => {
    formatTicketAccess(item);
    getTicketsForEvent(item.exerciseGroup.objectDb, item.exerciseGroup.objectId);
    //eslint-disable-next-line
  }, [item.objectId]);

  const getButtonTitle = () => {
    if (open) {
      return `${t("schowaj_bilety")}`;
    }
    return `${t("pokaz_bilety")}`;
  };

  return (
    <>
      <EAProductBanner
        title={item.name}
        pictureUrl={item.eventMessage}
        description={item.description}
        mainPrice={`${t("ceny_od")} ${lowestPrice}`}
        buttonTitle={getButtonTitle()}
        buttonStartIcon={<HiOutlineTicket />}
        buttonVariant={open ? "outlined" : "filled"}
        expanded={open}
        onClick={() => setOpen(!open)}
      >
        <div className="single-event-tickets">
          {showTicketLimits && (
            <div className="head-title flex-start-center">
              <span>
                {t("pozostalo")}:{" "}
                <b>
                  {item.capacity - item.reserved} {t("biletow")}
                </b>
              </span>
            </div>
          )}
          {item.capacity - item.reserved > 0 ? (
            <>
              {tickets.map((itemTicket, index) => (
                <div className={"ticket-block"} key={index}>
                  <TicketLineSummary
                    item={itemTicket}
                    exercise={ticketAccess}
                    preBasket={preBasket}
                    addItemToBasket={addItemToBasket}
                    removeItemFromBasket={removeItemFromBasket}
                    qntState={qntState}
                  />
                </div>
              ))}
            </>
          ) : (
            <div className="alert alert-red">{t("wszystkie_bilety_zostaly_sprzedane")}</div>
          )}

          <PreBasketSummary preBasket={preBasket} clearBasket={handleDeleteBasket} />
        </div>
      </EAProductBanner>
    </>
  );
};

export default EventSingle;
